import {
  HouseChatPreviewIcon,
  HouseChatsStatusFilter,
  IHouseChatPreview,
} from './types';
import { ChatConnectionStatus } from 'http-requests/house-chats';

// Реальные chat_id с бэка всегда положительные — используем
// отрицательный sentinel, чтобы переиспользовать draftsByChatId (текст
// композера) для раздела массовых рассылок без отдельного поля/API стора.
export const MASS_MAILING_DRAFT_ID = -1;

export const CHATS_PAGE_SIZE = 20;
export const HISTORY_PAGE_SIZE = 50;
export const UNREAD_CONTEXT = 5;
export const HISTORY_UNREAD_MAX_LOAD = 100;
export const HISTORY_CACHE_LIMIT = 20;
export const ATTACHMENTS_TAB_PAGE_SIZE = 30;

// ограничивает число параллельных /get_attachment — иначе при скролле истории
// с множеством вложений разом улетают десятки запросов и блокируют остальные
// (лимит соединений браузера на домен)
export const ATTACHMENT_RESOLVE_CONCURRENCY = 5;

// decode+resize миниатюры — CPU-bound, а не сетевой лимит, поэтому порог
// ниже, чем у ATTACHMENT_RESOLVE_CONCURRENCY
export const THUMBNAIL_CONCURRENCY = 3;

export const IMAGE_ATTACHMENT_TYPES = ['image', 'photo'];

// показать в панели нечем, поэтому такие вложения выкидываем на входе —
// они не должны попадать ни в превью, ни в сообщение, ни во вкладки
export const IGNORED_ATTACHMENT_TYPES = ['share'];

export const STATUS_FILTERS: HouseChatsStatusFilter[] = [
  'all',
  'connected',
  'disconnected',
];

// порядок групп в сайдбаре — совпадает с тем, в каком бэк отдаёт /chats,
// нужен на клиенте только чтобы не терять его при локальном пересчёте
// сортировки (перемещение чата наверх по новому сообщению без рефетча)
export const CHAT_STATUS_ORDER: ChatConnectionStatus[] = [
  'connected',
  'disconnected',
  'bot_not_admin',
  'bot_not_added',
];

export const NO_MESSAGE_PREVIEW: IHouseChatPreview = {
  text: 'Нет сообщений',
  icons: [],
  isMuted: true,
  thumbnails: [],
};

export const ICON_BY_ATTACHMENT_TYPE: Record<string, HouseChatPreviewIcon> = {
  image: 'image',
  photo: 'image',
  video: 'video',
  audio: 'audio',
  voice: 'audio',
};

export const MAX_ATTACHMENT_ICONS = 10;

// сколько раз подряд пробуем перезапросить chats/house_chat_status при
// первой загрузке раздела, прежде чем показать блокирующую ошибку вместо
// бесконечных повторов
export const MAX_INITIAL_LOAD_ATTEMPTS = 5;
